
import Vue, { VueConstructor } from 'vue'
import { mapGetters, mapActions, mapMutations } from 'vuex'

import RLoader from '@/components/forms/RLoader.vue'
import UserCard from '@/components/admin/UserCard.vue'
import UserResources from '@/components/modals/UserResources.vue'
import { UserProxy } from '@/api/types/user'
import { apiGetIdToken } from '@/api/functions'
import { RButton } from '@/components/'

import CopyText from '@/mixins/CopyText'

export default (Vue as VueConstructor<Vue & InstanceType<typeof CopyText>>).extend({
  name: 'UsersList',
  components: {
    UserCard,
    UserResources,
    RLoader,
    RButton,
  },
  mixins: [CopyText],
  data() {
    return {
      search: '',
      idToken: '',
    }
  },
  mounted() {
    this.loadAllUsers()
    this.setSelectedUserId(null)
    this.setUsage([])
  },
  methods: {
    async getIdToken() {
      const data = await apiGetIdToken()
      this.idToken = data
    },
    async handleClick() {
      await this.getIdToken()
      this.copyText(this.idToken)
    },
    ...mapActions({
      loadAllUsers: 'admin/loadAllUsers',
    }),
    ...mapMutations({
      setSelectedUserId: 'admin/setSelectedUserId',
      setUsage: 'event/setUsage',
    }),
  },
  computed: {
    ...mapGetters({
      users: 'admin/users',
      request: 'admin/getAllUsersRequest',
    }),
    sortedAndFilteredUsers(): Array<UserProxy> {
      const result = [...this.users]
      const search = this.search.toLowerCase()
      result.sort((a, b) => {
        if (b.runningWorkstations.length !== a.runningWorkstations.length) {
          return b.runningWorkstations.length - a.runningWorkstations.length
        } else {
          return b.workstations.length - a.workstations.length
        }
      })
      if (!search) {
        return result
      } else {
        return result.filter((u) => {
          return (
            u.email.toLowerCase().includes(search) ||
            u.finalDisplayName.toLowerCase().includes(search) ||
            String(u.workstations.length) === search ||
            String(u.runningWorkstations.length) === search ||
            String(u.drives.length) === search
          )
        })
      }
    },
    loading(): boolean {
      return this.request.pending
    },
    success(): boolean {
      return this.request.successful && this.users.length > 0
    },
    failed(): boolean {
      return !this.loading && !this.success
    },
    failedMsg(): string {
      if (this.request.failed) {
        return `ERROR: ${this.request.error}`
      } else if (!this.request.pending && this.users.length === 0) {
        return 'ERROR: Empty list of users'
      }
      return ''
    },
    count(): number {
      return this.users.length
    },
  },
})
